import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Row, Col, Button, Card } from "react-bootstrap";

//
import SectionTitle from "../general/SectionTitle";
import SubscriptionAlertBox from "../general/SubscriptionAlertBox";
import DesktopAlertItem from "./DesktopAlertItem";
import MobileAlertItem from "./MobileAlertItem";
import BoxLoading from "../general/BoxLoading";
import NothingToShow from "../general/NothingToShow";

//
import { getLatestAlerts } from "../../redux/features/coins/actions";
import { connect } from "react-redux";

function AlertBox({ windowSize }) {
  const [loading, setLoading] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [limit, setLimit] = useState(10);

  /**
   * Get Latest Alerts
   */
  const get_latest_alerts = async () => {
    // start loading
    setLoading(true);

    // request
    await getLatestAlerts().then((res) => {
      if (res) {
        setAlerts(res);
      }
    });

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    get_latest_alerts();

    // eslint-disable-next-line
  }, []);

  return (
    <>
      <SectionTitle text="Latest Crypto Alert" />

      {/* <Card style={{ height: "331px" }}>
        <SubscriptionAlertBox
          title="The alerts listed here are historical alerts."
          subject=" Please subscribe to get full access and receive new alerts. "
        />
      </Card> */}

      {alerts.length ? (
        <>
          {windowSize > 576 ? (
            <Row className="alerts">
              {alerts.slice(0, limit).map((item) => (
                <DesktopAlertItem data={item} key={item.name} />
              ))}
            </Row>
          ) : (
            <Card className="gutter-b">
              <Card.Body className="p-0">
                {alerts.slice(0, limit).map((item) => (
                  <MobileAlertItem item={item} key={item.name} />
                ))}
              </Card.Body>
            </Card>
          )}

          {limit < alerts.length && (
            <Button
              variant="white"
              size="lg"
              className="d-block m-auto see-more"
              onClick={() => setLimit(limit + 6)}
            >
              See More
            </Button>
          )}
        </>
      ) : (
        <Card className="gutter-b">
          <NothingToShow text={loading ? "Loading..." : "Nothing to show"} />
          {loading && <BoxLoading />}
        </Card>
      )}
    </>
  );
}

AlertBox.propTypes = {
  windowSize: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(AlertBox);
